module.exports = __webpack_public_path__ + "img/hdp1.382b87d3.png";